export default {
    props: {
        categoryAxisAutoBaseUnitStepsMilliseconds: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.milliseconds'
        },
        categoryAxisAutoBaseUnitStepsSeconds: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.seconds'
        },
        categoryAxisAutoBaseUnitStepsMinutes: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.minutes'
        },
        categoryAxisAutoBaseUnitStepsHours: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.hours'
        },
        categoryAxisAutoBaseUnitStepsDays: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.days'
        },
        categoryAxisAutoBaseUnitStepsWeeks: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.weeks'
        },
        categoryAxisAutoBaseUnitStepsMonths: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.months'
        },
        categoryAxisAutoBaseUnitStepsYears: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.years'
        },
        categoryAxisAxisCrossingValue: {
            type: [Object, Date, Array, String, Number],
            default: undefined,
            kComposite: 'categoryAxis.axisCrossingValue'
        },
        categoryAxisBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.background'
        },
        categoryAxisBaseUnit: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.baseUnit'
        },
        categoryAxisBaseUnitStep: {
            type: [Number, String],
            default: undefined,
            kComposite: 'categoryAxis.baseUnitStep'
        },
        categoryAxisCategories: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.categories'
        },
        categoryAxisColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.color'
        },
        categoryAxisCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.color'
        },
        categoryAxisCrosshairDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.dashType'
        },
        categoryAxisCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.opacity'
        },
        categoryAxisCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.background'
        },
        categoryAxisCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.border.color'
        },
        categoryAxisCrosshairTooltipBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.border.dashType'
        },
        categoryAxisCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.border.width'
        },
        categoryAxisCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.color'
        },
        categoryAxisCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.font'
        },
        categoryAxisCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.format'
        },
        categoryAxisCrosshairTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.padding'
        },
        categoryAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.padding.bottom'
        },
        categoryAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.padding.left'
        },
        categoryAxisCrosshairTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.padding.right'
        },
        categoryAxisCrosshairTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.padding.top'
        },
        categoryAxisCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.template'
        },
        categoryAxisCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.visible'
        },
        categoryAxisCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.visible'
        },
        categoryAxisCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.width'
        },
        categoryAxisField: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.field'
        },
        categoryAxisJustified: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.justified'
        },
        categoryAxisLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.background'
        },
        categoryAxisLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.border.color'
        },
        categoryAxisLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.border.dashType'
        },
        categoryAxisLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.border.width'
        },
        categoryAxisLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.color'
        },
        categoryAxisLabelsCulture: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.culture'
        },
        categoryAxisLabelsDateFormatsDays: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.dateFormats.days'
        },
        categoryAxisLabelsDateFormatsHours: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.dateFormats.hours'
        },
        categoryAxisLabelsDateFormatsMonths: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.dateFormats.months'
        },
        categoryAxisLabelsDateFormatsWeeks: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.dateFormats.weeks'
        },
        categoryAxisLabelsDateFormatsYears: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.dateFormats.years'
        },
        categoryAxisLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.font'
        },
        categoryAxisLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.format'
        },
        categoryAxisLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.margin'
        },
        categoryAxisLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.margin.bottom'
        },
        categoryAxisLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.margin.left'
        },
        categoryAxisLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.margin.right'
        },
        categoryAxisLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.margin.top'
        },
        categoryAxisLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.labels.mirror'
        },
        categoryAxisLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.padding'
        },
        categoryAxisLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.padding.bottom'
        },
        categoryAxisLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.padding.left'
        },
        categoryAxisLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.padding.right'
        },
        categoryAxisLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.padding.top'
        },
        categoryAxisLabelsRotation: {
            type: [Number, String],
            default: undefined,
            kComposite: 'categoryAxis.labels.rotation'
        },
        categoryAxisLabelsRotationAlign: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.rotation.align'
        },
        categoryAxisLabelsRotationAngle: {
            type: [Number, String],
            default: undefined,
            kComposite: 'categoryAxis.labels.rotation.angle'
        },
        categoryAxisLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.skip'
        },
        categoryAxisLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.step'
        },
        categoryAxisLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'categoryAxis.labels.template'
        },
        categoryAxisLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.labels.visible'
        },
        categoryAxisLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'categoryAxis.labels.visual'
        },
        categoryAxisLineColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.line.color'
        },
        categoryAxisLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.line.dashType'
        },
        categoryAxisLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.line.visible'
        },
        categoryAxisLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.line.width'
        },
        categoryAxisMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.majorGridLines.color'
        },
        categoryAxisMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.majorGridLines.dashType'
        },
        categoryAxisMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.majorGridLines.visible'
        },
        categoryAxisMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorGridLines.width'
        },
        categoryAxisMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorGridLines.step'
        },
        categoryAxisMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorGridLines.skip'
        },
        categoryAxisMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.majorTicks.color'
        },
        categoryAxisMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorTicks.size'
        },
        categoryAxisMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.majorTicks.visible'
        },
        categoryAxisMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorTicks.width'
        },
        categoryAxisMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorTicks.step'
        },
        categoryAxisMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorTicks.skip'
        },
        categoryAxisMax: {
            type: [Object, Number],
            default: undefined,
            kComposite: 'categoryAxis.max'
        },
        categoryAxisMaxDateGroups: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.maxDateGroups'
        },
        categoryAxisMin: {
            type: [Object, Number],
            default: undefined,
            kComposite: 'categoryAxis.min'
        },
        categoryAxisMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.minorGridLines.color'
        },
        categoryAxisMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.minorGridLines.dashType'
        },
        categoryAxisMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.minorGridLines.visible'
        },
        categoryAxisMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorGridLines.width'
        },
        categoryAxisMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorGridLines.step'
        },
        categoryAxisMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorGridLines.skip'
        },
        categoryAxisMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.minorTicks.color'
        },
        categoryAxisMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorTicks.size'
        },
        categoryAxisMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.minorTicks.visible'
        },
        categoryAxisMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorTicks.width'
        },
        categoryAxisMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorTicks.step'
        },
        categoryAxisMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorTicks.skip'
        },
        categoryAxisName: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.name'
        },
        categoryAxisPane: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.pane'
        },
        categoryAxisPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.plotBands'
        },         categoryAxisReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.reverse'
        },
        categoryAxisRoundToBaseUnit: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.roundToBaseUnit'
        },
        categoryAxisSelectFrom: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.select.from'
        },
        categoryAxisSelectMax: {
            type: [Object, Number],
            default: undefined,
            kComposite: 'categoryAxis.select.max'
        },
        categoryAxisSelectMin: {
            type: [Object, Number],
            default: undefined,
            kComposite: 'categoryAxis.select.min'
        },
        categoryAxisSelectMousewheelReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.select.mousewheel.reverse'
        },
        categoryAxisSelectMousewheelZoom: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.select.mousewheel.zoom'
        },
        categoryAxisSelectTo: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.select.to'
        },
        categoryAxisStartAngle: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.startAngle'
        },
        categoryAxisTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.background'
        },
        categoryAxisTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.border.color'
        },
        categoryAxisTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.border.dashType'
        },
        categoryAxisTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.border.width'
        },
        categoryAxisTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.color'
        },
        categoryAxisTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.font'
        },
        categoryAxisTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.margin'
        },
        categoryAxisTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.margin.bottom'
        },
        categoryAxisTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.margin.left'
        },
        categoryAxisTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.margin.right'
        },
        categoryAxisTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.margin.top'
        },
        categoryAxisTitlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.padding'
        },
        categoryAxisTitlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.padding.bottom'
        },
        categoryAxisTitlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.padding.left'
        },
        categoryAxisTitlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.padding.right'
        },
        categoryAxisTitlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.padding.top'
        },
        categoryAxisTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.position'
        },
        categoryAxisTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.rotation'
        },
        categoryAxisTitleText: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.text'
        },
        categoryAxisTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.title.visible'
        },
        categoryAxisTitleVisual: {
            type: Function,
            default: undefined,
            kComposite: 'categoryAxis.title.visual'
        },
        categoryAxisType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.type'
        },
        categoryAxisVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.visible'
        },
        categoryAxisWeekStartDay: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.weekStartDay'
        },
        categoryAxisNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.position'
        },
        categoryAxisNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.icon.background'
        },
        categoryAxisNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.icon.border.color'
        },
        categoryAxisNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.notes.icon.border.width'
        },
        categoryAxisNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.notes.icon.size'
        },
        categoryAxisNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.icon.type'
        },
        categoryAxisNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.notes.icon.visible'
        },
        categoryAxisNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.background'
        },
        categoryAxisNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.border.color'
        },
        categoryAxisNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.border.dashType'
        },
        categoryAxisNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.border.width'
        },
        categoryAxisNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.color'
        },
        categoryAxisNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.font'
        },
        categoryAxisNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'categoryAxis.notes.label.template'
        },
        categoryAxisNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.visible'
        },
        categoryAxisNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.rotation'
        },
        categoryAxisNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.format'
        },
        categoryAxisNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.position'
        },
        categoryAxisNotesLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.line.dashType'
        },
        categoryAxisNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.notes.line.width'
        },
        categoryAxisNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.line.color'
        },
        categoryAxisNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.notes.line.length'
        },
        categoryAxisNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.notes.data'
        },         categoryAxisNotesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'categoryAxis.notes.visual'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/CategoryAxis.js